@if (hasFeedback$ | async) {
  <button mat-icon-button (click)="openFeedbackList()">
    <mat-icon
      fontIcon="flag"
      class="material-symbols-outlined feedback-icon"
      [matTooltip]="tooltip$ | async"
    >
      feedback
    </mat-icon>
  </button>
}
